import { NgModule } from '@angular/core';
import { WsSelectorIaBinding } from './bindings/ws-selector-ia.binding';
import { WsSelectorIaSwitchComponent } from './presentation/ws-selector-ia-switch/ws-selector-ia-switch.component';
import { WsSyncOverlayComponent } from './presentation/ws-sync-overlay/ws-sync-overlay.component';
import { WsSyncLogsModalComponent } from './presentation/ws-sync-logs-modal/ws-sync-logs-modal.component';

@NgModule({
  imports: [
    WsSelectorIaSwitchComponent,
    WsSyncOverlayComponent,
    WsSyncLogsModalComponent,
  ],
  exports: [
    WsSelectorIaSwitchComponent,
    WsSyncOverlayComponent,
    WsSyncLogsModalComponent,
  ],
  providers: [...WsSelectorIaBinding],
})
export class WsSelectorIaModule {}
